import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/auth/login-form/login.component';
import { LogoutComponent } from './components/auth/logout/logout.component';
import { RegistroComponent } from './components/auth/registro/registro.component';
import { IdentGuard } from './guards/ident.guard';
import { IsAuthGuard } from './guards/isAuth.guard';
import { NoAuthGuard } from './guards/NoAuth.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ChatComponent } from './components/chat/chat.component';
import { SearchClientComponent } from './components/search-client/search-client.component';
import { ConsultaPsicometricoComponent } from './components/consulta-psicometrico/consulta-psicometrico.component';
import { ListOnlineComponent } from './components/list-online/list-online.component';
import { profile } from 'console';
import { ProfilesComponent } from './components/profiles/profiles.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { ContactProfileComponent } from './components/contact-profile/contact-profile.component';
import { ConsultQuoteComponent } from './components/consult-quote/consult-quote.component';
import { CreditOptionComponent } from './components/credit-option/credit-option.component';
import { CreditCalculatorComponent } from './components/credit-calculator/credit-calculator.component';
import { CreditSaveComponent } from './components/credit-save/credit-save.component';
import { CreditSaveV2Component } from './components/credit-save-v2/credit-save-v2.component';
import { ConsultQuotaComponent } from './components/consult-quota/consult-quota.component';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { ApproveConditionsComponent } from './components/approve-conditions/approve-conditions.component';
import { ApprovalPoliciesComponent } from './components/approval-policies/approval-policies.component';
import { ContactOnboardingComponent } from './components/contact-onboarding/contact-onboarding.component';
import { ContactSapComponent } from './components/contact-sap/contact-sap.component';
import { SapHubComponent } from './components/sap-hub/sap-hub.component';
import { ContactOdooComponent } from './components/contact-odoo/contact-odoo.component';
import { PostComponent } from './components/post/post.component';
import { OtrosFlujosPagoComponent } from './components/otros-flujos-pago/otros-flujos-pago.component';
import { NotaCreditoComponent } from './components/nota-credito/nota-credito.component';
import { ContactFinancialPaymentsComponent } from './components/contact-financial-payments/contact-financial-payments.component';
import { PersonFeePaymentsComponent } from './components/person-fee-payments/person-fee-payments.component';

import { PersonPaymentsComponent } from './components/person-payments/person-payments.component';
import { PersonPaymentsTableComponent } from './components/person-payments-table/person-payments-table.component';
import { PersonPaymentsSwitcherComponent } from './components/person-payments-switcher/person-payments-switcher.component';
import { TarifarioComponent } from './components/comercios/tarifario/tarifario.component';
import { FeriadosComponent } from './components/comercios/feriados/feriados.component';
import { LiquidacionDiaComponent } from './components/liquidacion/liquidacion-dia/liquidacion-dia.component';
import { LiquidacionGuiaComponent } from './components/liquidacion/liquidacion-guia/liquidacion-guia.component';
import { LiquidacionConsultasComponent } from './components/liquidacion/liquidacion-consultas/liquidacion-consultas.component';
import { CuentasOrigenComponent } from './components/liquidacion/cuentas-origen/cuentas-origen.component';
import { ParametrosLiquidacionComponent, PERMISOS_LIQUIDACION } from './components/liquidacion/parametros-liquidacion/parametros-liquidacion.component';
import { BandasComponent } from './components/liquidacion/bandas/bandas.component';
import { IntegracionesComponent } from './components/liquidacion/integraciones/integraciones.component';
import { AtencionComerciosComponent } from './components/liquidacion/atencion-comercios/atencion-comercios.component';
import { PreferenciasComponent } from './components/preferencias/preferencias.component';
import { WebcamComponent } from 'ngx-webcam';
import { BiometriaComponent } from './components/biometria/biometria.component';
import { FinancialPaymentsComponent } from './components/financial-payments/financial-payments.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { FinancePaymentsTableComponent } from './components/finance-payments-table/finance-payments-table.component';
import { FinancePaymentsSwitcherComponent } from './components/finance-payments-switcher/finance-payments-switcher.component';
import { DashboardFeesComponent } from './components/dashboard-fees/dashboard-fees.component';
import { ProcesosMasivosComponent } from './components/procesos-masivos/procesos-masivos.component';
import { ProcesoDetalleComponent } from './components/procesos-masivos/proceso-detalle/proceso-detalle.component';
import { CarteraComponent } from './components/cartera/cartera.component';
import { ClienteDetalleComponent } from './components/cliente-detalle/cliente-detalle.component';
import { NewFeeComponent } from './components/new-fee/new-fee.component';

import { StadisticComponent } from './components/stadistic/stadistic.component';
import { InstallmentsConsoleComponent } from './components/installments-console/installments-console.component';
import { ReportComponent } from './components/report/report.component';
import { ContactsApprovatedComponent } from './components/contacts-approvated/contacts-approvated.component';
import { ApproveConditinsViewComponent } from './components/approve-conditins-view/approve-conditins-view.component';
import { ExportComponent } from './components/export/export.component';
import { CreateContactComponent } from './components/create-contact/create-contact.component';
import { DashboardInviceComponent } from './components/dashboard-invice/dashboard-invice.component';
import { UsersComponent } from './components/users/users.component';
import { FinancalDashboardComponent } from './components/financal-dashboard/financal-dashboard.component';
import { VentasDashboardComponent } from './components/ventas-dashboard/ventas-dashboard.component';
import { MulticomercioDashboardComponent } from './components/multicomercio-dashboard/multicomercio-dashboard.component';
import { Finanzas2DashboardComponent } from './components/finanzas2-dashboard/finanzas2-dashboard.component';
import { CobranzaDashboardComponent } from './components/cobranza-dashboard/cobranza-dashboard.component';
import { CreditoDashboardComponent } from './components/credito-dashboard/credito-dashboard.component';
import { QuotaHistoryGlobalComponent } from './components/quota-history-global/quota-history-global.component';
import { ParametrosSistemaDashboardComponent } from './components/parametros-sistema-dashboard/parametros-sistema-dashboard.component';
import { StadisticDashboardComponent } from './components/stadistic-dashboard/stadistic-dashboard.component';
import { StadisticEjecutivesComponent } from './components/stadistic-ejecutives/stadistic-ejecutives.component';
import { IsProfileGuard } from './guards/isProfile.guard';
import { OdooPanelComponent } from './components/odoo/odoo-panel/odoo-panel.component';
import { IsPermissionGuard } from './guards/isPermission.guard';
import { DashboardDirecDebitComponent } from './components/dashboard-direc-debit/dashboard-direc-debit.component';
import { DashboardDirectDebitAffiliationComponent } from './components/dashboard-direct-debit-affiliation/dashboard-direct-debit-affiliation.component';
import { DomiciliacionCtAvanceComponent } from './components/domiciliacion-ct-avance/domiciliacion-ct-avance.component';
import { DomiciliationConfigDashboardComponent } from './components/domiciliation-config-dashboard/domiciliation-config-dashboard.component';
import { RegistroCobrosArchivoComponent } from './components/registro-cobros-archivo/registro-cobros-archivo.component';

import { DirecDebitHistoryComponent } from './components/direc-debit-history/direc-debit-history.component';
import { DirecDebitAlliancesHistoryComponent } from './components/direc-debit-alliances-history/direc-debit-alliances-history.component';
import { DirecDebitAfiliationsHistoryComponent } from './components/direc-debit-afiliations-history/direc-debit-afiliations-history.component';

import { NotificationXlsxComponent } from './components/notification-xlsx/notification-xlsx.component';
import { RatesComponent } from './components/rates/rates.component';
import { AccountsAdminComponent } from './components/accounts-admin/accounts-admin.component';
import { PaymentOptionsComponent } from './components/payment-options/payment-options.component';
import { DeactivationCategoriesComponent } from './components/deactivation-categories/deactivation-categories.component';
import { CarteraCastigadaComponent } from './components/cartera-castigada/cartera-castigada.component';
import { BdvAsyncManagementComponent } from './components/bdv-async-management/bdv-async-management.component';
import { BdvConsultasComponent } from './components/bdv-consultas/bdv-consultas.component';

import { PlansComponent } from './components/plans/plans.component';
import { CargaMasivaClientComponent } from './components/carga-masiva-client/carga-masiva-client.component';
import { CargaMasivaAprobacionesComponent } from './components/carga-masiva-aprobaciones/carga-masiva-aprobaciones.component';
import { CargaMasivaCuposComponent } from './components/carga-masiva-cupos/carga-masiva-cupos.component';
import { CargaMasivaCuposRewardsComponent } from './components/carga-masiva-cupos-rewards/carga-masiva-cupos-rewards.component';
import { CargaMasivaC004Component } from './components/carga-masiva-c004/carga-masiva-c004.component';

import { DashboardDirecDebitAlliancesComponent } from './components/dashboard-direc-debit-alliances/dashboard-direc-debit-alliances.component';
import { ClientPlansComponent } from './components/person-plans/person-plans.component';
import { ClientsStadisticAuthComponent } from './components/clients-stadistic-auth/clients-stadistic-auth.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { InactiveQuotaComponent } from './inactive-quota/inactive-quota.component';
import { CodesComponent } from './components/codes/codes.component';
import { CodeDynamicComponent } from './code-dynamic/code-dynamic.component';
import { CodeTypeProductComponent } from './components/type-product/code-type-product/code-type-product.component';
import { PayallBalanceComponent } from './components/payall-balance/payall-balance.component';
import { RecargasComponent } from './components/recargas/recargas.component';
import { OperadorasListComponent } from './components/recargas/operadoras-list/operadoras-list.component';
import { TiposOperacionComponent } from './components/recargas/tipos-operacion/tipos-operacion.component';
import { ProductosComponent } from './components/recargas/productos/productos.component';
import { RecargasAdminComponent } from './admin/recargas-admin/recargas-admin.component';
import { PlanDetailComponent } from './components/plans/plan-detail/plan-detail.component';
import { PlansWizardComponent } from './components/plans/components/plans-wizard/plans-wizard.component';
import { PlansWizardEditComponent } from './components/plans/components/plans-wizard-edit/plans-wizard-edit.component';
import { DashboardRedistributePaymentComponent } from './components/dashboard-redistribute-payment/dashboard-redistribute-payment.component';
import { ClientInstallmentsViewComponent } from './components/client-installments-view/client-installments-view.component';
import { AsyncAdminDashboardComponent } from './components/async-admin-dashboard/async-admin-dashboard.component';
import { PerfilBancarioComponent } from './components/perfil-bancario/perfil-bancario.component';
import { CashRegisterSimulatorComponent } from './components/cash-register-simulator/cash-register-simulator.component';
import { BancoPlazaConsoleComponent } from './components/banco-plaza-console/banco-plaza-console.component';
import { ComerciosListComponent } from './components/comercios/comercios-list/comercios-list.component';
import { ComerciosDetailComponent } from './components/comercios/comercios-detail/comercios-detail.component';
import { ComerciosTiendaComponent } from './components/comercios/comercios-tienda/comercios-tienda.component';
import { ComerciosUsuarioNuevoComponent } from './components/comercios/comercios-usuario-nuevo/comercios-usuario-nuevo.component';
import { ComerciosFormComponent } from './components/comercios/comercios-form/comercios-form.component';
import { ComerciosCondicionesComponent } from './components/comercios/comercios-condiciones/comercios-condiciones.component';
import { ComerciosCondicionesFormComponent } from './components/comercios/comercios-condiciones-form/comercios-condiciones-form.component';
import { CierreDeCajaComponent } from './components/cierre-de-caja/cierre-de-caja.component';
// 🔴 REDISEÑO 2026-09-20 — las siete pantallas que vivían adentro de la ficha
// del comercio como solapas. Cada una es ahora una ruta de verdad: enlace
// compartible, atrás del navegador y carga propia.
import { ComerciosTiendasComponent } from './components/comercios/comercios-tiendas/comercios-tiendas.component';
import { ComerciosTiendaNuevaComponent } from './components/comercios/comercios-tienda-nueva/comercios-tienda-nueva.component';
import { ComerciosCuentasComponent } from './components/comercios/comercios-cuentas/comercios-cuentas.component';
import { ComerciosClientesComponent } from './components/comercios/comercios-clientes/comercios-clientes.component';
import { ComerciosContactosComponent } from './components/comercios/comercios-contactos/comercios-contactos.component';
import { ComerciosUsuariosComponent } from './components/comercios/comercios-usuarios/comercios-usuarios.component';
import { ComerciosAsistenteComponent } from './components/comercios/comercios-asistente/comercios-asistente.component';
import { ComerciosTemasComponent } from './components/comercios/comercios-temas/comercios-temas.component';
import { IaComponent } from './components/ia/ia/ia.component';
import { IaEstadoComponent } from './components/ia/ia-estado/ia-estado.component';
import { IaAgentesComponent } from './components/ia/ia-agentes/ia-agentes.component';
import { IaComerciosComponent } from './components/ia/ia-comercios/ia-comercios.component';
import { IaBitacoraComponent } from './components/ia/ia-bitacora/ia-bitacora.component';
import { IaProbarComponent } from './components/ia/ia-probar/ia-probar.component';
import { SolicitudesCreditoListComponent } from './components/solicitudes-credito/solicitudes-credito-list/solicitudes-credito-list.component';
import { SolicitudesCreditoDetalleComponent } from './components/solicitudes-credito/solicitudes-credito-detalle/solicitudes-credito-detalle.component';
import { TiposFlujosComponent } from './components/tipos-flujos/tipos-flujos.component';
import { TipoFlujoDetalleComponent } from './components/tipos-flujos/tipo-flujo-detalle/tipo-flujo-detalle.component';
import { WorkflowsListaComponent } from './components/workflows/workflows-lista/workflows-lista.component';
import { WorkflowDetalleComponent, WorkflowSinGuardarGuard } from './components/workflows/workflow-detalle/workflow-detalle.component';
import { AltasBandejaComponent } from './components/altas/altas-bandeja/altas-bandeja.component';
import { LiquidacionFirmaComponent } from './components/liquidacion/liquidacion-firma/liquidacion-firma.component';
import { AltaNuevaComponent } from './components/altas/alta-nueva/alta-nueva.component';
import { AltaSolicitudComponent } from './components/altas/alta-solicitud/alta-solicitud.component';
import { AltaCargarComponent } from './components/altas/alta-cargar/alta-cargar.component';
import { DocumentacionIntegracionComponent } from './components/documentacion-integracion/documentacion-integracion.component';
import { OrganizacionComponent } from './components/organizacion/organizacion.component';
import { ShopsListComponent } from './components/shops/shops-list/shops-list.component';
import { ShopDetailComponent } from './components/shops/shop-detail/shop-detail.component';
import { SeguridadAvanzadaComponent } from './components/security/seguridad-avanzada/seguridad-avanzada.component';
import { AppClientsComponent } from './components/app-clients/app-clients.component';
import { RolesPermisosComponent } from './components/roles-permisos/roles-permisos.component';
import { InsuranceConsoleComponent } from './components/insurance-console/insurance-console.component';
import { AppConfigComponent } from './components/app-config/app-config.component';
import { CatalogProductsComponent } from './components/catalog-products/catalog-products.component';
import { CatalogProductDetailComponent } from './components/catalog-products/catalog-product-detail/catalog-product-detail.component';
import { InsuranceDomiciliationSimulatorComponent } from './components/insurance-domiciliation-simulator/insurance-domiciliation-simulator.component';

// Widget embebido CRM (sin auth guards — JWT via query param)
import { WidgetPaymentHistoryComponent } from './components/widget-payment-history/widget-payment-history.component';
import { WidgetCreditHistoryComponent } from './components/widget-credit-history/widget-credit-history.component';
import { WidgetPostComponent } from './components/widget-post/widget-post.component';
import { WidgetInstallmentsPlanComponent } from './components/widget-installments-plan/widget-installments-plan.component';

const routes: Routes = [
  /*{
    path: 'console',
    loadChildren: () => import('./modules/la/la.module').then(m => m.LaModule),
    canActivate: [AuthGuard]

  },*/
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'register',
    component: RegistroComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/financial-payments',
    component: FinancialPaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/financial-payments/:shop',
    component: FinancialPaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/payments',
    component: FinancePaymentsSwitcherComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    // Acceso directo a la vista tabla (fallback si falla la clásica)
    path: 'console/payments/tabla',
    component: FinancePaymentsTableComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    // Acceso directo a la vista clásica (fallback si falla la tabla)
    path: 'console/payments/classic',
    component: PaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    path: 'console/fees',
    component: DashboardFeesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/insurance-domiciliation-simulator',
    component: InsuranceDomiciliationSimulatorComponent,
    canActivate: [IsAuthGuard],
  },

  {
    path: 'console/procesos-masivos',
    component: ProcesosMasivosComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: { profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },
  {
    path: 'console/procesos-masivos/:id',
    component: ProcesoDetalleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: { profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },
  {
    path: 'console/cartera',
    component: CarteraComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: { profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },
  {
    path: 'console/cliente/:code',
    component: ClienteDetalleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    // RBAC: pide contactos.vista_morosidad.ver_detalle_completo (no Cartera y Mora); lo lee IsProfileGuard
    data: { profiles: ['OWNER', 'ADMIN', 'ANALIST'], permission: 'contactos.vista_morosidad.ver_detalle_completo' },
  },

  {
    path: 'redirect',
    component: DashboardComponent,
    canActivate: [IsAuthGuard],
  },

  {
    path: 'console/dashboard',
    component: DashboardComponent,
    canActivate: [IsAuthGuard],
  },

  {
    path: 'console/constacts',
    component: ContactsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/users',
    component: UsersComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/create-constacts',
    component: CreateContactComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/constacts-status',
    component: ContactsApprovatedComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/search-client',
    component: SearchClientComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/psicometrico',
    component: ConsultaPsicometricoComponent,
    canActivate: [IsAuthGuard],
  },
  {
    path: 'console/person/profile/:code',
    component: ContactProfileComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    path: 'console/person/onboarding/:code',
    component: ContactOnboardingComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/person/sap/:code',
    component: ContactSapComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    path: 'console/person/odoo/:code',
    component: ContactOdooComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['contactos.gestion_odoo.read'],
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/odoo',
    component: OdooPanelComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.integracion_odoo.read'],
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/sap-integracion',
    component: SapHubComponent,
    canActivate: [IsAuthGuard],
  },
  {
    path: 'console/person/financial-payments/:code',
    component: ContactFinancialPaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/person/client-installments-view/:code',
    component: ClientInstallmentsViewComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/person/distri/:code',
    component: DashboardRedistributePaymentComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/online',
    component: ListOnlineComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/credit-option',
    component: CreditOptionComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/consult-quota',
    component: ConsultQuotaComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/credit-calculator',
    component: CreditCalculatorComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/credit-save',
    component: CreditSaveComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Nueva creación de crédito — ruta aparte a propósito: convive con la de
  // arriba para poder compararlas con datos reales antes de reemplazar nada.
  {
    path: 'console/credit-save-v2',
    component: CreditSaveV2Component,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/invoice-detail/:code',
    component: InvoiceComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  { path: 'client-quota', component: ConsultQuoteComponent },

  {
    path: 'verification/approve-conditions/:code',
    component: ApproveConditionsComponent,
  },

  {
    path: 'console/payment/:invoice/:installment',
    component: PostComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    path: 'console/post/person/:code_person/:fee/:installment',
    component: PostComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },

  {
    path: 'console/payments/person-fees/:code',
    component: PersonFeePaymentsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    // Ruta base: renderiza la vista (tabla o clásica) según la preferencia del admin.
    path: 'console/payments/person/:code',
    component: PersonPaymentsSwitcherComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },
  {
    // Acceso directo a la vista de tabla (fallback / enlaces directos).
    path: 'console/payments/person/:code/tabla',
    component: PersonPaymentsTableComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },

  {
    path: 'console/post',
    component: PostComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },

  {
    path: 'console/post/person/:code_person',
    component: PostComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
    },
  },

  // Otros flujos de pago: registrar sin conciliar / registrar y anular. Solo OWNER.
  {
    path: 'console/otros-flujos-pago/person/:code_person',
    component: OtrosFlujosPagoComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Nota de crédito: aplica una devolución a un crédito específico del cliente.
  // Va por RBAC (no por perfil fijo): el módulo debe poder asignarse a
  // colaboradores concretos desde Roles y Perfiles.
  {
    path: 'console/nota-credito/person/:code_person',
    component: NotaCreditoComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['pagos.nota_credito.read', 'pagos.nota_credito.create'],
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/stadistic',
    component: StadisticComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/export',
    component: ExportComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: [
        'reportes.cartera_clientes.export', 'reportes.cartera_credito.export',
        'reportes.clientes_domiciliados.export', 'reportes.cuotas.export',
        'reportes.distribucion_pagos.export', 'reportes.biometria.export',
        'reportes.pagos.export', 'reportes.estadistica_registros.export',
        'reportes.pagos_penalidades.export', 'reportes.penalidades.export',
        'reportes.planes_clientes.export', 'reportes.bdv_transacciones.export',
        'reportes.pagos_sap.export', 'reportes.giros_sap.export', 'reportes.sap_business_partner.export', 'reportes.sap_partidas_abiertas.export', 'reportes.sap_perdidas_incobrables.export',
        'reportes.seguros.export', 'reportes.pagos_seguros.export',
        'reportes.operativo_seguros.export', 'reportes.cartera_seguros.export',
        'reportes.pagos_seguro_kredit.export', 'reportes.cuotas_seguros.export',
        'reportes.sap_bdv_seguros.export', 'reportes.sap_mercantil_seguros.export',
        'reportes.sap_plaza_seguros.export'
      ],
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/installments-console',
    component: InstallmentsConsoleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['EJECUTIVE', 'OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/stadistic_approved',
    component: ReportComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: [
        'reportes.cartera_clientes.export', 'reportes.cartera_credito.export',
        'reportes.clientes_domiciliados.export', 'reportes.cuotas.export',
        'reportes.distribucion_pagos.export', 'reportes.biometria.export',
        'reportes.pagos.export', 'reportes.estadistica_registros.export',
        'reportes.pagos_penalidades.export', 'reportes.penalidades.export',
        'reportes.planes_clientes.export', 'reportes.bdv_transacciones.export',
        'reportes.pagos_sap.export', 'reportes.giros_sap.export', 'reportes.sap_business_partner.export', 'reportes.sap_partidas_abiertas.export', 'reportes.sap_perdidas_incobrables.export',
        'reportes.fees_reactivacion.export'
      ],
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/invoice-dashboard',
    component: DashboardInviceComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/dashboard-direct-debit',
    component: DashboardDirecDebitComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/dashboard-direct-debit-alliances',
    component: DashboardDirecDebitAlliancesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/dashboard-direct-debit-affiliation',
    component: DashboardDirectDebitAffiliationComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/direct-debit-history',
    component: DirecDebitHistoryComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/domiciliation-config',
    component: DomiciliationConfigDashboardComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['cobranza.domiciliaciones.dashboard'],
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/domiciliacion-ct-avance',
    component: DomiciliacionCtAvanceComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.domiciliacion_ct.read'],
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/registro-cobros-archivo',
    component: RegistroCobrosArchivoComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['cobranza.domiciliaciones.dashboard'],
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/direct-debit-afiliations-history',
    component: DirecDebitAfiliationsHistoryComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/direct-debit-alliances-history',
    component: DirecDebitAlliancesHistoryComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'FINANCIAL'],
    },
  },

  {
    path: 'console/finacial-dashboard',
    component: FinancalDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'FINANCIAL'],
    },
  },

  // Panel de Multicomercio (21-oct): solo reúne los accesos; cada pantalla conserva su guard.
  {
    path: 'console/multicomercio',
    component: MulticomercioDashboardComponent,
    canActivate: [IsAuthGuard],
  },

  {
    path: 'console/ventas',
    component: VentasDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/finanzas2',
    component: Finanzas2DashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'FINANCIAL', 'ACCOUNTING_ANALYST'],
    },
  },

  {
    path: 'console/cobranza',
    component: CobranzaDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST', 'FINANCIAL'],
    },
  },

  {
    path: 'console/credito',
    component: CreditoDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/credito/quota-history-global',
    component: QuotaHistoryGlobalComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/parametros-sistema',
    component: ParametrosSistemaDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/seguridad-avanzada',
    component: SeguridadAvanzadaComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.seguridad.read'],
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/app-clients',
    component: AppClientsComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.clientes_app.read'],
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/roles-permisos',
    component: RolesPermisosComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.roles_permisos.read'],
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/parametros-sistema/insurance-console',
    component: InsuranceConsoleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/parametros-sistema/app-config',
    component: AppConfigComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/estadisticas',
    component: StadisticDashboardComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: [
        'reportes.cartera_clientes.export', 'reportes.cartera_credito.export',
        'reportes.clientes_domiciliados.export', 'reportes.cuotas.export',
        'reportes.distribucion_pagos.export', 'reportes.biometria.export',
        'reportes.pagos.export', 'reportes.estadistica_registros.export',
        'reportes.pagos_penalidades.export', 'reportes.penalidades.export',
        'reportes.planes_clientes.export', 'reportes.bdv_transacciones.export',
        'reportes.pagos_sap.export', 'reportes.giros_sap.export', 'reportes.sap_business_partner.export', 'reportes.sap_partidas_abiertas.export', 'reportes.sap_perdidas_incobrables.export',
        'reportes.fees_reactivacion.export'
      ],
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/notificacion-xlsx',
    component: NotificationXlsxComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/carga-masiva-cleinte-xlsx',
    component: CargaMasivaClientComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/carga-masiva-aprobaciones-xlsx',
    component: CargaMasivaAprobacionesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/carga-masiva-cupos',
    component: CargaMasivaCuposComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/carga-masiva-cupos-rewards',
    component: CargaMasivaCuposRewardsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/credito/reactivaciones-masivas',
    component: CargaMasivaC004Component,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/inactivate-quota',
    component: InactiveQuotaComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/estadisticas-ejecutivos',
    component: StadisticEjecutivesComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: [
        'reportes.cartera_clientes.export', 'reportes.cartera_credito.export',
        'reportes.clientes_domiciliados.export', 'reportes.cuotas.export',
        'reportes.distribucion_pagos.export', 'reportes.biometria.export',
        'reportes.pagos.export', 'reportes.estadistica_registros.export',
        'reportes.pagos_penalidades.export', 'reportes.penalidades.export',
        'reportes.planes_clientes.export', 'reportes.bdv_transacciones.export',
        'reportes.pagos_sap.export', 'reportes.giros_sap.export', 'reportes.sap_business_partner.export', 'reportes.sap_partidas_abiertas.export', 'reportes.sap_perdidas_incobrables.export',
        'reportes.fees_reactivacion.export'
      ],
      profiles: ['OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/rates',
    component: RatesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/accounts-admin',
    component: AccountsAdminComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/plans',
    component: PlansComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/plans/new',
    component: PlansWizardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/plans/edit/:code',
    component: PlansWizardEditComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/plans/detail/:code',
    component: PlanDetailComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/person/plans/:code',
    component: ClientPlansComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/client-stadistic',
    component: ClientsStadisticAuthComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/code-dynamic',
    component: CodeDynamicComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Duplicados eliminados: estadisticas-ejecutivos, rates, accounts-admin, plans, client-stadistic
  // (Ya definidos arriba con IsProfileGuard)

  {
    path: 'console/notifications',
    component: NotificationsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/codigos',
    component: CodesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/type_product',
    component: CodeTypeProductComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/payall-balance',
    component: PayallBalanceComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  {
    path: 'console/recargas',
    component: RecargasComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
    children: [
      {
        path: '',
        redirectTo: 'operadoras',
        pathMatch: 'full'
      },
      {
        path: 'operadoras',
        component: OperadorasListComponent
      },
      {
        path: 'tipos/:code',
        component: TiposOperacionComponent
      },
      {
        path: 'productos/:operatorCode/:typeCode',
        component: ProductosComponent
      }
    ]
  },

  {
    path: 'console/recargas-admin',
    component: RecargasAdminComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // ===================================
  // SISTEMA DE GANANCIAS PAYALL (Módulo Lazy)
  // ===================================
  {
    path: 'console/ganancias',
    loadChildren: () => import('./components/ganancias/ganancias.module').then(m => m.GananciasModule),
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  // ===================================
  // SISTEMA DE PAYMENT OPTIONS
  // ===================================
  {
    path: 'console/payment-options',
    component: PaymentOptionsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/payment-options/:id/accounts',
    component: AccountsAdminComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Catálogo de categorías de desactivación de cupo
  {
    path: 'console/parametros-sistema/deactivation-categories',
    component: DeactivationCategoriesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Cartera Castigada (Pérdidas Incobrables)
  {
    path: 'console/parametros-sistema/cartera-castigada',
    component: CarteraCastigadaComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Liquidación a comercios (4.6a, 08-oct): el día y el cierre. Solo con su permiso (estricto en el núcleo).
  // Consultas de liquidación (cambio 9): historial y demás, por rango de fechas.
  {
    path: 'console/liquidacion/consultas',
    component: LiquidacionConsultasComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['liquidacion.consultar'],
      profiles: ['OWNER'],
    },
  },
  // Guía de liquidación (GUI-09): la ve quien consulta la liquidación o verifica cuentas (el guard acepta ALGUNO de la lista).
  {
    path: 'console/liquidacion/guia',
    component: LiquidacionGuiaComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['liquidacion.consultar', 'config.comercios_cuentas.verify'],
      profiles: ['OWNER'],
    },
  },
  // Firma de tanda: la solicitud del workflow de Juan que se abre desde «Altas de comercios» (Mario, 26-oct R29; WFT-10).
  {
    path: 'console/liquidacion/firma/:id',
    component: LiquidacionFirmaComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: { permissions: ['liquidacion.consultar'], profiles: ['OWNER'] },
  },
  {
    path: 'console/liquidacion',
    component: LiquidacionDiaComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['liquidacion.consultar'],
      profiles: ['OWNER'],
    },
  },

  // Liquidación a comercios en Parámetros (PAR-02, Mario 12-oct): una sola opción con las de liquidación adentro.
  {
    path: 'console/parametros-sistema/liquidacion',
    component: ParametrosLiquidacionComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: PERMISOS_LIQUIDACION,
      profiles: ['OWNER'],
    },
  },
  // Cuentas de origen (3.4; Mario 08-oct): de dónde sale el pago; las administra la gerente de finanzas.
  {
    path: 'console/parametros-sistema/cuentas-origen',
    component: CuentasOrigenComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.cuentas_origen.update'],
      profiles: ['OWNER'],
    },
  },
  // Atención a comercios (EJE-02, Mario 14-oct): el contacto general del portal del comercio.
  {
    path: 'console/parametros-sistema/atencion-comercios',
    component: AtencionComerciosComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.comercios.update'],
      profiles: ['OWNER'],
    },
  },
  // Integraciones bancarias (INT-01 a 05, Mario 09-oct): el formato de cada banco como configuración, con versiones y prueba.
  {
    path: 'console/parametros-sistema/integraciones',
    component: IntegracionesComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['liquidacion.consultar'],
      profiles: ['OWNER'],
    },
  },
  // Bandas de aprobación (4.6c, 08-oct): versionadas; propone la gerente, aprueba el director.
  {
    path: 'console/parametros-sistema/bandas',
    component: BandasComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.bandas.read'],
      profiles: ['OWNER'],
    },
  },

  // Feriados bancarios (1.6a, Mario 08-oct): los usa la fecha de pago con «hábil siguiente».
  {
    path: 'console/parametros-sistema/feriados',
    component: FeriadosComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.feriados.read'],
      profiles: ['OWNER'],
    },
  },

  // Tarifario de liquidación (Mario, 07-oct-2026): la tabla de plazos que alimenta las condiciones.
  {
    path: 'console/parametros-sistema/tarifario',
    component: TarifarioComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.comercios.terms.read'],
      profiles: ['OWNER'],
    },
  },

  // Preferencias de la consola
  {
    path: 'console/parametros-sistema/preferencias',
    component: PreferenciasComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.preferencias.read'],
      profiles: ['OWNER'],
    },
  },

  // Políticas de Aprobación
  {
    path: 'console/approval-policies',
    component: ApprovalPoliciesComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/bdv-async-management',
    component: BdvAsyncManagementComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  {
    path: 'console/bdv-consultas',
    component: BdvConsultasComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // ===================================
  // SIMULADOR DE CAJA REGISTRADORA
  // ===================================
  {
    path: 'console/caja',
    component: CashRegisterSimulatorComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  // ===================================
  // BANCO PLAZA - DÉBITO INMEDIATO
  // ===================================
  {
    path: 'console/banco-plaza',
    component: BancoPlazaConsoleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  // ===================================
  // GESTIÓN DE TIENDAS
  // ===================================
  {
    path: 'console/merchants',
    component: ComerciosListComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  // 🔴 2026-09-28 — el comercio ya no nace acá: nace del alta. `ComerciosFormComponent`
  // sigue vivo (lo usa 'editar', la ficha de abajo); esta ruta sólo redirige a quien
  // la tenga guardada o la escriba a mano. 'nuevo' va ANTES de ':code', o Angular lo
  // toma como el código de un comercio.
  {
    path: 'console/merchants/nuevo',
    redirectTo: 'console/altas/nueva',
    pathMatch: 'full',
  },
  {
    path: 'console/merchants/:code/editar',
    component: ComerciosFormComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  // 🔴 'condiciones/nueva' ANTES de ':code'. Es el alta a pantalla completa y
  //    NO es una vista de la ficha, asi que no baja a `children` — la ficha
  //    de al lado si: ver el comentario de la ruta hija 'condiciones'.
  {
    path: 'console/merchants/:code/condiciones/nueva',
    component: ComerciosCondicionesFormComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  // ═══════════════════════════════════════════════════════════════════════
  // LAS PANTALLAS QUE COLGABAN DE LA FICHA — rediseño 2026-09-20
  //
  // Eran siete solapas de `console/merchants/:code`, en un archivo de 1.843
  // lineas. Ahora son siete rutas: cada una se abre sola, se comparte por
  // enlace y carga solo lo suyo.
  //
  // 🔴 TODAS van ANTES de `console/merchants/:code`, que es la ficha: Angular
  // resuelve por orden y una ruta declarada despues de ':code' se alcanzaria
  // igual —tiene mas tramos— pero el orden se respeta por consistencia con las
  // hermanas que si dependen de el.
  //
  // Los mismos guardas y el mismo perfil que sus hermanas: quien entra a la
  // ficha entra a sus pantallas.
  // ═══════════════════════════════════════════════════════════════════════
  {
    path: 'console/merchants/:code/tiendas/nueva',
    component: ComerciosTiendaNuevaComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    // 🔴 VA DESPUES de `tiendas/nueva`, y no al reves: las dos tienen cuatro
    // tramos, asi que Angular toma la primera que encaje. Declarada antes,
    // ':shopCode' se comeria la palabra «nueva» y el alta abriria la ficha de
    // una tienda con codigo NUEVA, que no existe.
    //
    // 🔴 Y VA ANTES que la ficha del comercio: Angular resuelve por orden, y una
    // ruta mas especifica declarada despues nunca se alcanza.
    //
    // El detalle de la tienda es su PROPIA direccion —no un modal— para que
    // funcionen atras y adelante, y para que el enlace se pueda compartir.
    // Decision de Juan (2026-09-19): «no quiero un modal, imaginate todo eso en
    // un modalcito».
    path: 'console/merchants/:code/tiendas/:shopCode',
    component: ComerciosTiendaComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    // 🔴 TAMBIEN antes que la ficha del comercio, por el mismo motivo de orden.
    //
    // El alta de un usuario dejo de ser un modal el 2026-09-19: «igual que la
    // creacion de usuario, que tiene que ser un componente. Entiende que no me
    // gustan los modales». Con ruta propia hay atras, recarga y enlace, y el
    // formulario de la caja —tienda, caja, usuario, clave y confirmacion— entra
    // a ancho completo en vez de apretado en un dialogo.
    path: 'console/merchants/:code/usuarios/nuevo',
    component: ComerciosUsuarioNuevoComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/merchants/:code',
    component: ComerciosDetailComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
    // ══════════════════════════════════════════════════════════════════
    // 🔴 LAS SEIS SON HIJAS, NO HERMANAS — orden de Juan, 2026-09-20:
    //
    //   *«cuando le dé a tiendas, cuentas, por pagar, clientes,
    //   contactos, usuarios, condiciones, muéstrame y cámbiame la
    //   información que está abajo, en vez de pasarme por otro
    //   componente que después ni siquiera el atrás tiene»*.
    //
    // Anidadas se cumplen las dos cosas a la vez, que era lo que la
    // primera versión perdía: el encabezado, la tira del portal y la
    // barra de pestañas SE QUEDAN fijos y sólo se repinta el
    // `<router-outlet>` de abajo — pero sigue siendo una ruta, así que
    // la dirección cambia, el enlace se comparte y el atrás funciona.
    //
    // ⚠️ No llevan `canActivate` propio: el del padre ya corrió y una
    // hija no se alcanza sin pasar por él. Repetirlo sería dos guardas
    // que hay que mantener de acuerdo.
    children: [
      // tiendas
      { path: 'tiendas', component: ComerciosTiendasComponent, canActivate: [IsPermissionGuard], data: { permissions: ['config.comercios_tiendas.read'] } },
      // cuentas
      { path: 'cuentas', component: ComerciosCuentasComponent },
      // por-pagar — 2026-10-07 (Mario): los pagos a comercios van al módulo de Liquidación. Un enlace
      // viejo a …/por-pagar lleva a la ficha en vez de romperse.
      { path: 'por-pagar', redirectTo: '', pathMatch: 'full' },
      // clientes
      { path: 'clientes', component: ComerciosClientesComponent },
      // contactos
      { path: 'contactos', component: ComerciosContactosComponent, canActivate: [IsPermissionGuard], data: { permissions: ['config.comercios_contactos.read'] } },
      // usuarios
      { path: 'usuarios', component: ComerciosUsuariosComponent },
      // odoo — «Gestión en Odoo» del comercio (reutiliza la pantalla del cliente). Este hijo SÍ lleva guarda: lo que
      // abre es un permiso propio (`config.comercios_odoo.read`), no el perfil OWNER que ya exige el padre.
      // IsPermissionGuard lee `data.permissions` (RBAC); sin `profiles`, un usuario sin RBAC pasa (el servidor igual lo exige).
      {
        path: 'odoo',
        component: ContactOdooComponent,
        canActivate: [IsPermissionGuard],
        data: { tipo: 'comercio', permissions: ['config.comercios_odoo.read'] },
      },
      // ⚠️ CONDICIONES ES LA SÉPTIMA, y se quedó afuera hasta el 2026-09-21.
      // Estaba declarada como HERMANA de ':code', así que su pestaña sacaba de
      // la ficha y abría una pantalla entera — lo que Juan rechazó el 2026-09-20
      // nombrando «condiciones» en la lista.
      //
      // 🔴 `condiciones/nueva` SIGUE siendo una pantalla aparte, y tiene que
      // seguir declarada ANTES de ':code': es un formulario de alta a pantalla
      // completa, no una vista de la ficha. Angular resuelve por orden, así que
      // esa ruta gana antes de llegar acá.
      { path: 'condiciones', component: ComerciosCondicionesComponent },
      // ⚠️ «ASISTENTE DE IA» — la octava, 2026-09-25 (CONTRATO de `modules/ia` §8.2).
      // HIJA como sus hermanas, no hermana de ':code': es una vista de la ficha y
      // tiene que dejar fijos el encabezado y las solapas. Sin `canActivate`
      // propio: el del padre ya corrió.
      { path: 'asistente', component: ComerciosAsistenteComponent, canActivate: [IsPermissionGuard], data: { permissions: ['config.comercios_asistente.read'] } },
      // «TEMAS» — la novena, 2026-09-25 (Juan: el tema del portal se decide por comercio, aquí).
      // HIJA como sus hermanas; guarda con el PUT de la ficha, que ya es sólo de CrediTotal.
      { path: 'temas', component: ComerciosTemasComponent },
      // CIERRE DE CAJA — el menú y el servicio ya decían que vivía acá
      // (console/merchants/:code/cierre-de-caja), pero la ruta no estaba y la
      // dirección caía en el comodín. El comercio sale de `:code`.
      { path: 'cierre-de-caja', component: CierreDeCajaComponent },
    ],
  },

  // ===================================
  // INTELIGENCIA ARTIFICIAL — la IA del núcleo
  // Contrato: kredit-api-MT/modules/ia/CONTRATO.md §8.2.
  // Cinco solapas que son rutas hijas, con el mismo molde que la ficha del
  // comercio: la carcasa (`IaComponent`) deja fijos el encabezado, la cinta y
  // las solapas, y lo de abajo entra por su `<router-outlet>`.
  // 🔴 Los DOS sistemas de permisos: `data.profiles` aquí (el mismo OWNER que
  // Comercios) y `puedeVerIA`/`puedeConfigurarIA` en las plantillas
  // (`services/ia/ia-formato.ts`). La puerta de verdad es la del servidor
  // (`esDeCrediTotal` + `IA_PERFILES_QUE_CONFIGURAN`, §7.2).
  // ===================================
  {
    path: 'console/ia',
    component: IaComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
    children: [
      { path: '', component: IaEstadoComponent },
      { path: 'agentes', component: IaAgentesComponent },
      { path: 'comercios', component: IaComerciosComponent },
      { path: 'bitacora', component: IaBitacoraComponent },
      { path: 'probar', component: IaProbarComponent },
    ],
  },

  // ===================================
  // SOLICITUDES DE CRÉDITO — canal POS
  // Contrato: ~/Documents/multicomercio/competencia/60-modulo-solicitudes-contrato.md
  // 🔴 'nuevo' no aplica acá (no hay alta manual), pero el detalle SÍ va
  // después del listado por el mismo motivo que en comercios: no hay conflicto
  // de segmento porque no hay una ruta ':code' de un solo tramo debajo, así que
  // el orden no es crítico — se deja igual, después, por consistencia.
  // ===================================
  {
    path: 'console/solicitudes-credito',
    component: SolicitudesCreditoListComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ADMIN', 'ANALIST'],
    },
  },
  {
    path: 'console/solicitudes-credito/:code',
    component: SolicitudesCreditoDetalleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ADMIN', 'ANALIST'],
    },
  },

  // ===================================
  // ALTAS DE COMERCIOS — las solicitudes de alta que corren por el workflow (vista 4 de la maqueta,
  // aprobada por Juan el 2026-09-28). La bandeja, la nueva y el detalle, cada una en su ruta.
  // 🔴 `nueva` va ANTES de `:id`, que si no se la come. Actuar lo decide el núcleo con el rol de la etapa.
  // ===================================
  {
    path: 'console/altas',
    component: AltasBandejaComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: { permissions: ['config.workflows.read', 'config.workflows.update'], profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },
  {
    path: 'console/altas/nueva',
    component: AltaNuevaComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: { permissions: ['config.workflows.read', 'config.workflows.update'], profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },
  {
    // «Completar mi parte»: la carga paso a paso del perfil que tiene la solicitud (va antes de `:id`).
    path: 'console/altas/:id/cargar',
    component: AltaCargarComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: { permissions: ['config.workflows.read', 'config.workflows.update'], profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },
  {
    path: 'console/altas/:id',
    component: AltaSolicitudComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: { permissions: ['config.workflows.read', 'config.workflows.update'], profiles: ['OWNER', 'ADMIN', 'ANALIST'] },
  },

  // ===================================
  // WORKFLOWS — el motor de workflow de aprobación (`/api/workflows`, modules/workflow del núcleo).
  // Maqueta aprobada por Juan el 2026-09-28. La lista y el detalle de uno, cada uno en su ruta y a
  // ancho completo. La ruta pide el permiso «Consultar Altas y Workflows» (config.workflows.read);
  // escribir lo decide el núcleo con «Editar workflows». `profiles` queda de respaldo legado.
  // ===================================
  {
    path: 'console/workflows',
    component: WorkflowsListaComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    data: {
      permissions: ['config.workflows.read', 'config.workflows.update'],
      profiles: ['OWNER', 'ADMIN', 'ANALIST'],
    },
  },
  {
    path: 'console/workflows/:id',
    component: WorkflowDetalleComponent,
    canActivate: [IsAuthGuard, IsPermissionGuard],
    canDeactivate: [WorkflowSinGuardarGuard],
    data: {
      permissions: ['config.workflows.read', 'config.workflows.update'],
      profiles: ['OWNER', 'ADMIN', 'ANALIST'],
    },
  },

  // ===================================
  // TIPOS Y FLUJOS — canal POS
  // Catálogo de tipos de conexión + workflows (GET .../admin/catalogo-solicitudes).
  // 🔴 Sólo lectura: no hay alta, edición ni borrado. Las dos rutas son la portada (los
  // cuatro tipos con su recorrido) y el detalle de uno.
  // ===================================
  {
    path: 'console/tipos-flujos',
    component: TiposFlujosComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ADMIN', 'ANALIST'],
    },
  },
  // 🔴 El detalle de un tipo, en su propia pantalla y a ancho completo — no en un modal ni en un
  // acordeón (regla de la casa). Va DESPUÉS del listado: ':code' es un tramo suelto y se comería
  // cualquier ruta hermana que se agregue más adelante si fuera primero.
  {
    path: 'console/tipos-flujos/:code',
    component: TipoFlujoDetalleComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ADMIN', 'ANALIST'],
    },
  },

  // ===================================
  // DOCUMENTACIÓN DE INTEGRACIÓN — canal POS
  // Los manuales técnicos (marketplace y caja) y la colección de Postman, para bajar y mandarle
  // a un comercio que se va a integrar. Los archivos los sube Juan a mano a `assets/manuales/`.
  // ===================================
  {
    path: 'console/documentacion-integracion',
    component: DocumentacionIntegracionComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ADMIN', 'ANALIST'],
    },
  },

  // ===================================
  // CIERRE DE CAJA — canal POS
  // «Los administradores también pueden bajarse un cierre de caja donde le traiga
  // todos los créditos, cuándo fue la inicial y cuánto fue, y cuánto se financió»
  // (Juan, 2026-09-20). Lee `GET /api/integracion-pos/comercio/caja/cierre-detallado`.
  //
  {
    path: 'console/organizacion',
    component: OrganizacionComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/shops',
    component: ShopsListComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  {
    path: 'console/shops/:code',
    component: ShopDetailComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // ===================================
  // MÓDULO DE GESTIÓN DE PRODUCTOS
  // ===================================
  {
    path: 'console/catalog-products',
    component: CatalogProductsComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },
  {
    path: 'console/catalog-products/detail/:code',
    component: CatalogProductDetailComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER', 'ANALIST'],
    },
  },

  // Ruta raíz - redirecciona a create-constacts
  {
    path: '',
    redirectTo: '/console/create-constacts',
    pathMatch: 'full'
  },

  // Ruta para console sin subrutas - redirecciona a create-constacts
  {
    path: 'console',
    redirectTo: '/console/create-constacts',
    pathMatch: 'full'
  },
  {
    path: 'console/async-admin',
    component: AsyncAdminDashboardComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },
  // Perfil bancario: perfil activo, historial y Cuentas por contrato (solo consulta del switch). Se entra desde Pagos Asíncronos.
  {
    path: 'console/perfil-bancario',
    component: PerfilBancarioComponent,
    canActivate: [IsAuthGuard, IsProfileGuard],
    data: {
      profiles: ['OWNER'],
    },
  },

  // Widget embebido CRM — sin auth guards, autenticado por JWT en query param
  {
    path: 'widget/payments/person/:personId',
    component: WidgetPaymentHistoryComponent,
  },
  {
    path: 'widget/credits/person/:personId',
    component: WidgetCreditHistoryComponent,
  },
  {
    path: 'widget/post/:code_person',
    component: WidgetPostComponent,
  },
  {
    path: 'widget/installments-plan/person/:personId',
    component: WidgetInstallmentsPlanComponent,
  },

  // Rutas no encontradas - redirecciona a create-constacts
  {
    path: '**',
    redirectTo: '/console/create-constacts',
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    /**
     * 🔴 `always` — para que una ruta HIJA vea los parámetros de su padre.
     *
     * Por omisión Angular usa `emptyOnly`: una hija sólo hereda los parámetros
     * si su padre no tiene componente. La ficha del comercio SÍ tiene
     * componente, así que sus seis hijas —tiendas, cuentas, por-pagar,
     * clientes, contactos, usuarios— pedían `paramMap.get('code')` a su propia
     * ruta y recibían `null`.
     *
     * Se vio en pantalla al tocar la pestaña Tiendas el 2026-09-20: la barra y
     * el encabezado quedaban bien y abajo salía «No encontramos el comercio "​"»,
     * con el código vacío. No falla nada y no hay error en la consola: el
     * componente pide un parámetro que existe un nivel más arriba y recibe
     * nada, que es un valor válido.
     *
     * Con `always` la hija hereda `:code` y las seis funcionan sin tocarlas.
     * La alternativa era `route.parent.paramMap` en cada una: seis lugares para
     * mantener de acuerdo, y el séptimo que alguien agregue se olvida.
     */
    paramsInheritanceStrategy: 'always',
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
